
























import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import * as temp from "../../_store/temp.module";
import { userUtils } from "../../_utils/userUtils";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import { InstituteInfo } from "../../_models/instituteInfo";

@Component({
  components: {
    CardTitle,
    DetailsDataTable
  }
})
export default class QuestionariWorkshop extends Vue {
  private dataTableParamsAz: any;
  private dataTableParamsTir: any;
  private createDialogParams: object;
  private titleParams: object;
  private listaQuestionariAllievi: any[];
  private listaQuestionariAziende: any[];

  constructor() {
    super();
    this.titleParams = {
      title: "QUESTIONARI WORKSHOP",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParamsAz = {
      headers: [
        {
          text: "Azienda",
          value: "denominazioneAzienda"
        },
        {
          text: "Data Questionario",
          value: "dataQuestionario"
        },
        {
          text: "Questionario",
          value: "questionarioWorkshopAzienda"
        }
        // {
        //   text: "Risorse da inserire",
        //   value: "scelta"
        // },
        // {
        //   text: "Referente",
        //   value: "referente"
        // },
        // {
        //   text: "Email Referente",
        //   value: "emailReferente"
        // }
      ],
      records: [],
      //   dialogParams: {
      //     title: "DETTAGLI TIROCINIO ESTIVO",
      //     type: "richiestaTirEstivoTab"
      //   },
      filterType: "questionariWorkshopAziende",
      listaArticolazioni: [
        {
          idArticolazione: "Tutte",
          nomeArticolazione: "Tutte"
        }
      ],
      type: "workshop"
    };
    this.dataTableParamsTir = {
      headers: [
        {
          text: "Allievo",
          value: "allievo"
        },
        {
          text: "Classe",
          value: "classe"
        },
        {
          text: "Data Questionario",
          value: "dataQuestionario"
        },
        {
          text: "Questionario",
          value: "questionarioWorkshopAllievo"
        }
      ],
      records: [],
      //   dialogParams: {
      //     title: "DETTAGLI TIROCINIO ESTIVO",
      //     type: "richiestaTirEstivoTab"
      //   },
      filterType: "questionariWorkshopAllievi",
      listaArticolazioni: [
        {
          idArticolazione: "Tutte",
          nomeArticolazione: "Tutte"
        }
      ],
      type: "workshop"
    };
    this.createDialogParams = {
      visible: false,
      type: ""
    };
    this.listaQuestionariAllievi = [];
    this.listaQuestionariAziende = [];
  }

  loadQuestionariWorkshop(idAnnoScolastico: number) {
    // var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico,
      idTipoQuestionario: 0
    };
    this.loadQuestionariAziende(payload);
    this.loadQuestionariAllievi(payload);
    // bus.$emit("dataLoaded");
  }

  loadQuestionariAziende(payload: any) {
    payload.idTipoQuestionario = 4;
    data
      .dispatchQuestionariWorkshopAziende(this["$store"], payload)
      .then(result => {
        this.dataTableParamsAz.records = result;
        this.listaQuestionariAziende = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  loadQuestionariAllievi(payload: any) {
    payload.idTipoQuestionario = 5;
    data
      .dispatchQuestionariWorkshopAllievi(this["$store"], payload)
      .then(result => {
        this.dataTableParamsTir.records = result;
        this.listaQuestionariAllievi = result;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            var instituteInfo = user.readInstituteInfo(this["$store"]);
            data
              .dispatchArticolazioni(this["$store"], instituteInfo.id)
              .then(response => {
                response.forEach(element => {
                  this.dataTableParamsAz.listaArticolazioni.push(element);
                  this.dataTableParamsTir.listaArticolazioni.push(element);
                });
                this.loadQuestionariWorkshop(idAnnoScolastico);
              });
            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("filtroQuestionariWorkshopAllievi", (filters: any) => {
      const listaQuestionariAllievi: any = this.listaQuestionariAllievi;
      var tempList: any = [];
      var tempList2: any = [];
      var tempList3: any = [];
      var tempList4: any = [];
      this.dataTableParamsTir.records = [];
      listaQuestionariAllievi.forEach((allievo: any) => {
        if (filters.filtroAutorizzazione !== "Tutti") {
          if (filters.filtroAutorizzazione === "Inviati") {
            if (allievo.idStatoDoc === 1) {
              tempList.push(allievo);
            }
          } else if (filters.filtroAutorizzazione === "Eliminati") {
            if (allievo.idStatoDoc === 3) {
              tempList.push(allievo);
            }
          } else if (filters.filtroAutorizzazione === "Confermati") {
            if (allievo.idStatoDoc === 2) {
              tempList.push(allievo);
            }
          }
        } else {
          tempList.push(allievo);
        }
      });
      tempList.forEach((item: any) => {
        if (filters.filtroAnni !== "Tutti") {
          if (filters.filtroAnni === "3") {
            if (item.classe.charAt(0) === "3") {
              tempList2.push(item);
            }
          } else if (filters.filtroAnni === "4") {
            if (item.classe.charAt(0) === "4") {
              tempList2.push(item);
            }
          } else if (filters.filtroAnni === "5") {
            if (item.classe.charAt(0) === "5") {
              tempList2.push(item);
            }
          }
        } else {
          tempList2.push(item);
        }
      });
      tempList2.forEach((item: any) => {
        if (filters.fitroArticolazione !== "Tutte") {
          if (filters.fitroArticolazione === "IT01") {
            if (item.idArticolazione === "IT01") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT04") {
            if (item.idArticolazione === "IT04") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT05") {
            if (item.idArticolazione === "IT05") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT10") {
            if (item.idArticolazione === "IT10") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT13") {
            if (item.idArticolazione === "IT13") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITAF") {
            if (item.idArticolazione === "ITAF") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITEN") {
            if (item.idArticolazione === "ITEN") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITET") {
            if (item.idArticolazione === "ITET") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITIA") {
            if (item.idArticolazione === "ITIA") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITMM") {
            if (item.idArticolazione === "ITMM") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "LI03") {
            if (item.idArticolazione === "LI03") {
              tempList3.push(item);
            }
          }
        } else {
          tempList3.push(item);
        }
      });
      tempList3.forEach((item: any) => {
        if (filters.filtroSezione != "Nessuna") {
          if (filters.filtroSezione === "A") {
            if (item.classe.charAt(2) === "A") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "B") {
            if (item.classe.charAt(2) === "B") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "C") {
            if (item.classe.charAt(2) === "C") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "D") {
            if (item.classe.charAt(2) === "D") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "E") {
            if (item.classe.charAt(2) === "E") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "F") {
            if (item.classe.charAt(2) === "F") {
              tempList4.push(item);
            }
          }
        } else {
          tempList4.push(item);
        }
      });
      this.dataTableParamsTir.records = tempList4;
    });

    bus.$on("changeAnnoScolasticoWorkshopAllievi", (payload: any) => {
      var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
      var payload2 = {
        idIstituto: instituteInfo.id,
        idAnnoScolastico: payload,
        idTipoQuestionario: 0
      };
      this.loadQuestionariAllievi(payload2);
    });

    bus.$on("changeAnnoScolasticoWorkshopAziende", (payload: any) => {
      var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
      var payload2 = {
        idIstituto: instituteInfo.id,
        idAnnoScolastico: payload,
        idTipoQuestionario: 0
      };
      this.loadQuestionariAziende(payload2);
    });
  }
}
